fx.ns("shared.stage", class CalendarLayoutArea  extends shared.stage.Area {
   
     constructor(data, model, parentContainer, side, preview) {
        super(data, model, parentContainer, side, preview);
     }


     create()
     {
        super.create();
        
        if (this.data.target == "page") // for page we display calendar
        {
            switch(this.data.shape)
            {
                case "desk" : 
                    this.stageContainer.addChild( new fx.components.Image(fx.assets.callendarDeskA5), {left : this.width()/2, top : 0, width : this.width()/2, height : this.height()});
                break;

                case "wall-double" : 
                    //this.stageContainer.addChild( new fx.components.Image(fx.assets.callendarWallA4), {left : 0, top : this.height()/2, width : this.width(), height : this.height()/2});
                break;

                case "wall-single" : 
                    this.stageContainer.addChild( new fx.components.Image(fx.assets.callendarPortrait), {left : 0, top : this.height()/2, width : this.width(), height : this.height()/2});
                break;
            }
        }
     }

});